/**
 * Styled Components - Created by miguelcanobbio on 13/07/18.
 */
import React from 'react'
import styled from 'styled-components'
import Checkbox from 'antd/lib/checkbox'
import Popover from 'antd/lib/popover'
import {
  RED,
  GRAY_BG,
  GRAY_LIGHT,
  GRAY_DARK,
  GREEN_LIGHT,
  GRAY_LIGHTEST
} from '../../../theme/colors'
import Icon from 'antd/lib/icon'

const MyPopover = ({ className, ...props }) => <Popover {...props} overlayClassName={className} />

export const Container = styled.tr`
  cursor: pointer;
  &:hover {
    background-color: ${GRAY_BG};
  }
`

interface CellProps {
  color?: string
  textAlign?: string
  small?: boolean
  positive?: boolean
}

export const Cell = styled.td`
  border-bottom: 1px solid ${GRAY_LIGHT};
  text-align: left;
  padding: ${({ positive }: CellProps) => positive ? '8px' : '8px 0'};
  color: ${({ color }: CellProps) => (color ? color : GRAY_DARK)};
  background-color: ${({ positive }: CellProps) => (positive ? GREEN_LIGHT : '')};
  background-clip: content-box;
  font-size: 14px;
  letter-spacing: 0.1px;
  height: 50px;
  text-align: ${({ textAlign }: CellProps) =>
    textAlign ? textAlign : 'start'};
  &.error {
    color: ${RED};
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: 10px;
  }

  @media (min-width: 331px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 12px;
  }

  @media (max-width: 330px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 11px;
  }
`

export const IconCell = styled(Cell)``

export const CheckboxStyled = styled(Checkbox)`
  width: 100%;
  text-align: center;
`

export const DesignPopover = styled(MyPopover)`
  .ant-popover-inner-content {
    padding: 4px 6px;
  }
`

export const DesignThumbnail = styled.img`
  object-fit: cover;
  max-width: 180px;
  height: 180px;
  padding: 8px;
  background: ${GRAY_LIGHTEST};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const StatusDiv = styled.div`
  font-size: 12px;
  align-items: center;
  display: flex;
`

export const StatusFlag = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`

export const ImportedIcon = styled(Icon)`
  font-size: 12px;
  transform: rotate(-90deg);
  background: white;
  color: #7c61b4;
  border-radius: 5px;
  padding: 4px;
  border: 1px solid #dcd1f6;
  box-shadow: none;
`

export const ThreeDIcon = styled.img`
  max-width: 24px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    filter: sepia(100%) hue-rotate(170deg) saturate(400%);
    transform: scale(1.2);
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyLocker/ItemOrder/styledComponents.tsx